import { render, staticRenderFns } from "./NotifyClientDialog.vue?vue&type=template&id=2269cd79&scoped=true"
import script from "./NotifyClientDialog.vue?vue&type=script&lang=js"
export * from "./NotifyClientDialog.vue?vue&type=script&lang=js"
import style0 from "./NotifyClientDialog.vue?vue&type=style&index=0&id=2269cd79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2269cd79",
  null
  
)

export default component.exports